// OneDrive:IgnoreCodeCoverage

export * from '@ms/telemetry-manager/lib/events/RUMOneDataUpload.event';
export { RUMOneDataUpload as default } from '@ms/telemetry-manager/lib/events/RUMOneDataUpload.event';
